var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifier"},[_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"notifier__message",class:{'notifier__message--error': message.isError()}},[_vm._v(_vm._s(message.text))])}),_vm._v(" "),_c('notifier-uploader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }